<template>
  <v-select
    flat
    :disabled="disabled || !savedPolygons.length"
    v-model="selectedPolygon"
    :items="savedPolygons"
    return-object
    prepend-icon="terrain"
    append-icon="keyboard_arrow_down" 
    persistent-hint
    :hint="$t('selecciona.poligono')"
    item-text="name"
  >
  </v-select>    
</template>

<script>
import PolygonGeom from 'ol/geom/polygon'
import Feature from 'ol/feature'

export default {
  props: ['disabled'],
  data() {
    return {
      selectedPolygon: null
    }
  },

  computed: {
    savedPolygons() {
      return this.$store.getters.savedPolygons
    },
  },

  watch: {
    selectedPolygon() {
      if(!this.selectedPolygon) {
        return
      }

      //console.log(this.selectedPolygon)

      const { name, coordinates } = this.selectedPolygon

      const feature = new Feature({
        name,
        geometry: new PolygonGeom(coordinates)
      })

      this.$emit('selected', feature)
    },
  }
}
</script>




// WEBPACK FOOTER //
// select-saved-polygon.vue?4613a46f